import Vue from "vue";
import { importAll } from "@/utils";

const requireContext = require.context("./", true, /\.js$/);
const directives = importAll(requireContext, "index");

for (let key in directives) {
  Vue.directive(key, directives[key]);
}
